<template>
  <div>
    <router-view @isFucountry="lisFucountry" :isdatacountry="datacountry"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      datacountry: ""
    };
  },
  methods: {
    lisFucountry(data) {
      // console.log("这是传到父级的参数" + data);
      this.datacountry = data;
      this.$router.push("/searchcountry");
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/view/country.vue